import React from "react";

const key1 = () => {
  return (
    <div>
      {" "}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="52"
        height="52"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M26.55 5.15001H26.45C26.1 5.15001 25.75 5.15001 25.4 5.15001V4.00001C25.4 2.30001 24 0.850006 22.25 0.850006H7.15C5.4 0.900006 4 2.30001 4 4.00001V21.1C4 21.75 4.25 22.35 4.7 22.85L12 30.35C12.45 30.85 13.1 31.1 13.8 31.1H22.95C24.3 31.1 25.45 30 25.45 28.6V28.15L27.85 23.3C27.95 23.15 27.95 23 27.95 22.8L28 6.60001C28 5.85001 27.35 5.20001 26.55 5.15001ZM25.75 9.20001H22.95V7.35001C23.9 7.35001 24.8 7.35001 25.75 7.35001V9.20001ZM22.2 7.40001C22.25 7.40001 22.25 7.40001 22.2 7.40001C22.25 7.40001 22.25 7.40001 22.2 7.40001ZM11.9 27L7.8 22.8H11.9V27ZM22.95 28.9H14.15V21.95C14.15 21.15 13.5 20.55 12.75 20.55H6.25V4.00001C6.25 3.50001 6.65 3.10001 7.15 3.10001H22.35C22.85 3.10001 23.25 3.50001 23.25 4.00001V5.10001C22.9 5.10001 22.6 5.10001 22.25 5.10001C21.4 5.10001 20.75 5.75001 20.75 6.55001L20.7 22.8C20.7 23 20.75 23.15 20.8 23.3L23.25 28.15V28.6C23.2 28.75 23.1 28.9 22.95 28.9ZM24.3 25.4L22.9 22.55V11.45H25.7V22.55L24.3 25.4Z"
          fill="url(#paint0_linear_39_11142)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_39_11142"
            x1="16"
            y1="0.850006"
            x2="16"
            y2="37.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="0.744792"
              stop-color="white"
              stop-opacity="0.364583"
            />
            <stop offset="1" stop-color="white" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default key1;
